import { Plan } from '../../../Templates/Plan';

export function Business({ kernel }) {
    return <Plan endpoint='/plans/business.json' />
}
